import { Submit as DefaultSubmit } from "../submit/submit";

import { Social as DefaultSocial } from "../social/social";

import { Separator as DefaultSeparator } from "../separator/separator";
import { Login as DefaultLogin } from "../login/login";
import { Input as DefaultInput } from "../input/input";
import { Error as DefaultError } from "../error/error";
import { useAccountCreationContext } from "../../hooks/account-creation-context";
import { ReactNode } from "react";
import Form from "@atlaskit/form";

export const Content = ({
    Submit = <DefaultSubmit />,
    Input = <DefaultInput />,
    Social = <DefaultSocial />,
    Separator = <DefaultSeparator />,
    Error = <DefaultError />,
    Login = <DefaultLogin />
}: {
    Submit?: ReactNode;
    Input?: ReactNode;
    Separator?: ReactNode;
    Social?: ReactNode;
    Error?: ReactNode;
    Login?: ReactNode;
}) => {
    const { onSubmit } = useAccountCreationContext();
    return (
        <>
            <Form onSubmit={onSubmit} isDisabled={false}>
                {({ formProps }) => (
                    <form
                        {...formProps}
                        autoComplete="off"
                        data-testid="account-creation"
                    >
                        {Input}
                        {Submit}
                    </form>
                )}
            </Form>
            {Error}
            {Separator}
            {Social}
            {Login}
        </>
    );
};
